import { InterviewHistoryListItemVO } from '@domain/vo/pass/interview/history/InterviewHistoryListVO';
import classNames from 'classnames/bind';
import { FC } from 'react';
import styles from './historyCard.module.scss';

const cx = classNames.bind(styles);

interface Props {
  data: InterviewHistoryListItemVO;
  openModal(id: number): void;
}

export const HistoryCard: FC<Props> = ({ data, openModal }) => {
  const handleClickCard = () => openModal(data.id);

  return (
    <button className={cx('card')} onClick={handleClickCard}>
      <div className={cx('videoArea')}>
        <video className={cx('video')} src={data.answerVideoUrl} />
      </div>
      <div className={cx('contents')}>
        {/* 썸네일 */}
        <div className={cx('intention')}>Q. {data.questionText}</div>
        <div className={cx('badgeArea')}>
          <div className={cx('badge')}>{data.badgeTitle}</div>
          {(!!data.jobTypeText || !!data.jobTitleText) && (
            <div className={cx('badge', 'sub')}>
              <span className={cx('item')}>{data.jobTypeText}</span>
              <span className={cx('item')}>{data.jobTitleText}</span>
            </div>
          )}
        </div>
      </div>
    </button>
  );
};
